<template>
	<footer class="main">				
		
	</footer>
</template>

<script type="text/javascript">
	export default {
        mounted() {
            
        }
    }
</script>